import AnalyticsWebClient, {envType, tenantType} from "@atlassiansox/analytics-web-client";
import {getEnvironment} from "./index";

const getEnvType = () => {
    const env = getEnvironment();
    switch (env) {
        case "LOCAL": return envType.LOCAL
        case "STAGING": return envType.STAGING
        case "PROD": return envType.PROD
        default: return envType.DEV
    }
}

function getAnalyticsClient() {
    return new AnalyticsWebClient(
        {
            env: getEnvType(), // required
            product: 'graphql-gateway', // required
            version: 'v2',
            locale: 'en-US',
            tenantIdType: tenantType.NONE
        },
        {
            flushBeforeUnload: false, // defaults to false
            useLegacyUrl: false, // defaults to false
            flushWaitInterval: false, // defaults to false
            logger: {} // defaults to console
        },
    );
}

export default getAnalyticsClient